<template>
  <div class="ai-list">
    <!-- <div class="ai-creation-list">
      <div class="ai-creation-title"></div>
      <div class="creation-item" @click="openDetail" v-for="(item, index) in creationList" :key="index">{{index +1 }}&nbsp;{{ item }}</div>
    </div> -->
    <div class="ai-hot-list">
      <div class="ai-hot-title">
        <img src="../../../assets/jfrb/hot-bg-2.png" alt="" />
      </div>
      <el-scrollbar
        v-if="list.length > 0"
        style="height: 460px; overflow-x: hidden"
        ref="scrollbar"
      >
        <div class="hot-item" v-for="(item, index) in list" :key="index">
          <div class="hot-title" @click="openDetail(item)">
            {{ item.title }}
          </div>
          <div class="hot-info">
            <span class="tags" v-if="item.class1">{{ item.class1 }}</span>
            <span class="time">{{ item.date }}</span>
            <!-- <span class="heat"
              >相关度<i>{{ parseFloat(item.score).toFixed(2) }}</i></span
            > -->
            <span class="heat-progressBar">
              <span class="heat-progressBar-value" :style="{ width: `${parseFloat(item.score).toFixed(2)*100}%` }"></span>
            </span>
          </div>
        </div>
      </el-scrollbar>
      <div class="noData" v-else>暂无数据</div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      title=""
      width="45%"
      @close="handleClose"
      :append-to-body="true"
      :lock-scroll="false"
      top="6vh"
    >
      <article-detail :articleDetail="articleDetail"></article-detail>
    </el-dialog>
  </div>
</template>

<script>
import ArticleDetail from "@/pages/views/project/components/ArticleDetail.vue";
import { GetJfrbArticle } from "@/api/index.js";
export default {
  components: {
    ArticleDetail
  },
  props: {
    hotList: {
      type: Array
    }
  },
  data() {
    return {
      dialogVisible: false,
      articleDetail: {},
      creationList: [],
      list: []
    };
  },
  watch: {
    hotList: {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          this.list = newVal;
        }
      },
      deep: true
    }
  },
  mounted() {},
  methods: {
    openDetail(item) {
      GetJfrbArticle({ id: item.id })
        .then((res) => {
          if (res.succeed) {
            // item.contenttxt = res.data.contenttxt
            this.articleDetail = res.data;
            this.dialogVisible = true;
          }
        })
        .catch((err) => {});
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-list {
  .ai-creation-list {
    background: #fff;
    margin-bottom: 20px;
    border-radius: 6px;
    .ai-creation-title {
      height: 54px;
      line-height: 54px;
      font-weight: 600;
      font-size: 20px;
      color: #222222;
      background: url("../../../assets/jfrb/creation-bg.png") no-repeat right;
    }
    .creation-item {
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      font-size: 16px;
      color: #222222;
      border-bottom: 1px solid #ebeef5;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .creation-item:last-child {
      border: none;
    }
  }
  .ai-hot-list {
    background: #fff;
    margin-bottom: 20px;
    border-radius: 6px;
    overscroll-behavior: contain;
    .ai-hot-title {
      height: 54px;
      line-height: 54px;
      font-weight: 600;
      font-size: 20px;
      color: #222222;
      // background: url("../../../assets/jfrb/hot-bg.png") no-repeat right;
      cursor: pointer;
    }
    .hot-item {
      padding: 10px 15px;
      border-bottom: 1px solid #ebeef5;
      &:last-child {
        border: none;
        padding-bottom: 100px;
      }
      .hot-title {
        font-weight: 400;
        font-size: 14px;
        color: #333;
        text-overflow: -o-ellipisis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        margin-bottom: 4px;
        cursor: pointer;
        &:hover {
          color: var(--brand);
        }
      }
      .hot-info {
        font-size: 12px;
        color: #7a7a7a;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tags {
          background: rgba(62, 157, 211, 0.1);
          padding: 2px 4px;
          color: var(--brand);
          font-size: 12px;
          margin-right: 8px;
        }
        .time {
          flex: 1;
        }
        .heat {
          margin-left: 40px;
          i {
            font-style: normal;
            font-weight: bold;
            font-size: 15px;
            color: #fe2d46;
            margin-left: 6px;
          }
        }
      }
    }
  }
}
.noData {
  color: var(--text-3);
  min-height: 100px;
  max-height: 460px;
  text-align: center;
  margin-top: 50px;
}
::v-deep .el-scrollbar__wrap {
  overscroll-behavior: contain;
}
.heat-progressBar {
  height: 6px;
  width: 64px;
  background-color: #dbdbdb;
  border-radius: 5px;
  position: relative;
}
.heat-progressBar-value {
  height: 6px;
  position: absolute;
  border-radius: 5px;
  left: 0;
  background: url("~@/assets/progress.png") no-repeat;
  background-size: cover;
}
</style>
